<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6
    id="impersonate-title"
    mat-dialog-title>
    {{ data.sysText.impersonate_title | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      mat-dialog-close
      [aria-label]="data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <p class="subtitle1 instructions">{{ data.sysText.impersonate_subtitle }}</p>
  <form [formGroup]="form">
    <!-- the field and search button stay while searching, so focus stays where it was: readonly, not disabled (a disabled field drops focus) -->
    @let isSearching = isSearching$ | async;
    <div class="field-container">
      <mat-form-field
        color="accent"
        [hintLabel]="(impersonate$ | async).additionalMatches ? (data.sysText.additionalMatchesFound | capitalizefirst) : ''">
        <mat-label>{{ data.sysText.search }}</mat-label>
        <input
          matInput
          formControlName="searchString"
          autocomplete="off"
          [readonly]="isSearching"/>
        @if (isSearching) {
          <mat-spinner matSuffix [diameter]="20" color="accent"></mat-spinner>
        }
        @if ((impersonate$ | async).eeList !== null) {
          <mat-hint align="end">
            {{ (impersonate$ | async)?.totalMatchesFound }}
            {{ (impersonate$ | async)?.eeList?.length === 1 ? data.sysText.matchFound : data.sysText.matchesFound }}
          </mat-hint>
        }
      </mat-form-field>
      <span class="spacer"></span>
      <button
        mat-icon-button
        color="accent"
        [attr.aria-label]="data.sysText.search_ariaLabel"
        type="submit"
        [disabled]="isSearching"
        disabledInteractive
        (click)="!isSearching && onSearch()">
        <mat-icon>search</mat-icon>
      </button>
    </div>
    @if (impersonate$ | async; as impersonate) {
      <mat-selection-list
        formControlName="eeId"
        [multiple]="false"
        aria-labelledby="impersonate-title">
        <!-- only the options hide while searching: removing the list itself shrank the dialog by its padding -->
        @if (!isSearching) {
          @for (ee of impersonate?.eeList; track ee) {
            <mat-list-option [value]="ee.eeId">{{ ee.contactName }}</mat-list-option>
          }
        }
      </mat-selection-list>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      mat-dialog-close
      [disabled]="isSubmitting">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- the button keeps focus while busy: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting || !eeId"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && eeId && login()">
    {{ data.sysText.impersonate_button }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>
